<template>
    <section class="mission-section card border-0 shadow-sm my-3">
        <div class="card-body p-3 p-md-4">
            <div class="section-header mb-3 mb-md-4">
                <div class="section-title-wrap">
                    <div class="section-icon section-icon-pending">
                        <i class="fa-regular fa-clock"></i>
                    </div>
                    <div>
                        <p class="section-kicker mb-1">Préparation</p>
                        <h5 class="section-title mb-0">
                            {{ missions.length > 0 ? 'Missions en attente' : 'Aucune mission en attente' }}
                        </h5>
                    </div>
                </div>
                <div class="section-tools">
                    <div class="filter-search">
                        <i class="fa-solid fa-magnifying-glass filter-search-icon"></i>
                        <input v-model.trim="search" type="search" class="form-control filter-input"
                            placeholder="Rechercher : mission, corridoring, chauffeur, véhicule, immat…" />
                    </div>

                    <div class="filter-meta">
                        <span v-if="search" class="result-badge">
                            {{ filteredMissions.length }} résultat{{ filteredMissions.length > 1 ? 's' : '' }}
                        </span>
                        <span v-else class="result-text">
                            {{ missions.length }} mission{{ missions.length > 1 ? 's' : '' }}
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="filteredMissions.length" class="row gx-4 gy-3 justify-content-start">
                <div v-for="mission in filteredMissions" :key="mission.id" class="col-auto">
                    <MissionDisplaySmall :mission="mission" :balise="this.balise" :escorte="mission.balises" />
                </div>
            </div>

            <div v-else class="empty-state">
                <div class="empty-state-icon empty-state-icon-pending">
                    <i class="fa-regular fa-folder-open"></i>
                </div>
                <div>
                    <h6 class="empty-state-title mb-1">
                        {{ search ? 'Aucun résultat pour cette recherche' : 'Aucune mission en attente' }}
                    </h6>
                    <p class="empty-state-text mb-0">
                        {{ search
                            ? 'Essaie un autre mot-clé pour retrouver une mission, un chauffeur ou un véhicule.'
                            : 'Les missions prêtes à être lancées apparaîtront ici.' }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import MissionDisplaySmall from './MissionDisplaySmall.vue'
import BaliseService from '@/services/balise.service'
import MissionRepository from '@/repositories/mission.repo'
import FormatHelper from '@/helpers/format.helper.js'


export default {
    components: {
        MissionDisplaySmall,
    },
    data() {
        return {
            missions: [],
            balise: {},
            search: '',
            timer: null
        };
    },
    computed: {
        filteredMissions() {
            const list = Array.isArray(this.missions) ? this.missions : [];
            const q = (this.search || '').toLowerCase();
            if (!q) return this.sortMissionsByDerivedTime(list);

            const includes = (v) => (v || '').toString().toLowerCase().includes(q);

            const filtered = list.filter(m => {
                // mission
                if (includes(m?.name)) return true;

                // corridoring
                if (includes(m?.corridoring?.name)) return true;

                // chauffeurs
                const members = Array.isArray(m?.members) ? m.members : [];
                for (const mem of members) {
                    if (includes(mem?.firstName) || includes(mem?.lastName)) return true;
                    if (includes(`${mem?.firstName || ''} ${mem?.lastName || ''}`.trim())) return true;
                }

                // véhicules: transporteur + convoi (escorte)
                const vehicles = [];
                if (m?.transporteur) vehicles.push(m.transporteur);
                if (Array.isArray(m?.balises)) vehicles.push(...m.balises);

                for (const b of vehicles) {
                    if (includes(b?.name)) return true;
                    if (includes(b?.immat)) return true;
                }

                return false;
            });

            return this.sortMissionsByDerivedTime(filtered);
        }
    },
    mounted() {
        this.refreshData();
        this.timer = setInterval(this.refreshData, 10000);
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
    methods: {
        sortMissionsByDerivedTime(list) {
            return [...list].sort((a, b) => {
                const aHasTime = Number.isFinite(a?.displayTimeSortValue);
                const bHasTime = Number.isFinite(b?.displayTimeSortValue);

                if (aHasTime && bHasTime) {
                    return a.displayTimeSortValue - b.displayTimeSortValue;
                }

                if (aHasTime) return -1;
                if (bHasTime) return 1;

                return (a?.name || '').localeCompare((b?.name || ''), 'fr', {
                    sensitivity: 'base'
                });
            });
        },

        // Get the balise data
        refreshData() {
            MissionRepository.getPending()
                .then(missions => { this.missions = missions; })
                .catch(e => {
                    console.log(e);
                });

            BaliseService.getBaliseInfo(2)
                .then(response => {
                    this.balise = FormatHelper.baliseInfoFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
    }
}
</script>


<style scoped>
.mission-section {
    border-radius: 22px;
    background: #ffffff;
    border: 1px solid #cfd8e3;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06) !important;
}

.card-body {
    padding-top: 1.25rem;
}

.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    padding-bottom: 1.1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid #dde5ee;
}

.section-title-wrap {
    display: flex;
    align-items: center;
    gap: 0.95rem;
}

.section-tools {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
    flex: 1 1 420px;
    min-width: 280px;
}

.section-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.section-icon-pending {
    color: #b7791f;
    background: rgba(245, 158, 11, 0.14);
}

.section-kicker {
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #64748b;
}

.section-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #0f172a;
}

.filter-search {
    position: relative;
    flex: 1 1 360px;
    max-width: 520px;
}

.filter-search-icon {
    position: absolute;
    top: 50%;
    left: 14px;
    transform: translateY(-50%);
    color: #94a3b8;
    pointer-events: none;
}

.filter-input {
    min-height: 42px;
    padding-left: 2.45rem;
    border-radius: 12px;
    border: 1px solid #d6dee8;
    background: #fff;
    box-shadow: none;
}

.filter-input:focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.12);
}

.filter-meta {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.result-badge {
    display: inline-flex;
    align-items: center;
    min-height: 34px;
    padding: 0.35rem 0.8rem;
    border-radius: 999px;
    background: rgba(13, 110, 253, 0.1);
    color: #0d6efd;
    font-size: 0.9rem;
    font-weight: 600;
}

.result-text {
    color: #64748b;
    font-size: 0.92rem;
    font-weight: 500;
}

.empty-state {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
    border: 1px dashed #cfd8e3;
    border-radius: 18px;
    background: #fcfdff;
}

.empty-state-icon {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    border: 1px solid #d6dee8;
    font-size: 1.25rem;
    flex-shrink: 0;
}

.empty-state-icon-pending {
    color: #b7791f;
}

.empty-state-title {
    font-weight: 700;
    color: #0f172a;
}

.empty-state-text {
    color: #64748b;
    line-height: 1.5;
}

@media (max-width: 767.98px) {
    .mission-section {
        border-radius: 18px;
    }

    .section-tools {
        flex: 1 1 100%;
        min-width: 100%;
        justify-content: stretch;
        flex-wrap: wrap;
    }

    .section-icon {
        width: 42px;
        height: 42px;
        border-radius: 12px;
    }

    .filter-search {
        flex-basis: 100%;
        max-width: 100%;
    }
}
</style>